<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <h2>
          Predogled:
        </h2>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text mr-2"
          @click="print"
        >
          Tiskaj
          <v-icon right dark>mdi-printer</v-icon>
        </v-btn>
        <div class="mb-2 d-md-none"></div>
        <v-btn
          color="#0F998E"
          class="white--text mr-2"
          @click="save"
        >
          Shrani
          <v-icon right dark>mdi-content-save-outline</v-icon>
        </v-btn>
        <div class="mb-2 d-md-none"></div>
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="send"
          v-if="false"
        >
          Poslji
          <v-icon right dark>mdi-email-send-outline</v-icon>
        </v-btn>
        <div class="mb-2 d-md-none"></div>
        <v-btn
          @click="closeWindow"
        >
          Prekliči
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="10" offset="1" md="8" offset-md="2">
        <pdf class="pdf-preview" :src="`data:application/pdf;base64,${base64pdf}`" v-for="i in numPages" :key="i" :page="i" @num-pages="setPages($event)"></pdf>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import printJS from 'print-js'
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  // props: ['id', 'base64Send', 'fileNameSend'],
  mixins: [
    asyncDataStatus
  ],
  components: {
    pdf
  },
  data () {
    return {
      numPages: 1,
      base64pdf: null,
      fileName: ''
    }
  },
  methods: {
    ...mapActions('invoices', ['getPdf']),
    print () {
      printJS({ printable: this.base64pdf, type: 'pdf', base64: true })
    },
    setPages (e) {
      if (e) {
        this.numPages = e
      }
    },
    save () {
      const linkSource = `data:application/pdf;base64,${this.base64pdf}`
      const downloadLink = document.createElement('a')

      downloadLink.href = linkSource
      downloadLink.download = this.fileName
      downloadLink.click()
    },
    send () {

    },
    closeWindow () {
      window.close()
    }
  },
  created () {
    /* if (this.id && this.id !== 'false') {
      this.getPdf(this.id)
        .then(response => {
          this.asyncDataStatus_fetched()
          this.base64pdf = response.data
          this.fileName = response.filename
        })
        .catch(anErr => {
          console.log(anErr)
          this.$notify({
            type: 'error',
            text: 'Prišlo je do napake pri pridobivanju računa.'
          })
        })
    } else {
      console.log('gottem', this.base64Send, this.$route.params)
      this.base64pdf = this.base64Send
      this.fileName = this.fileNameSend
      this.asyncDataStatus_fetched()
    } */
    const dataStorage = JSON.parse(localStorage.getItem('parametri'))
    this.base64pdf = dataStorage.base64
    this.fileName = dataStorage.fileName
    this.asyncDataStatus_fetched()
  }
}
</script>

<style scoped>
.pdf-preview {
  border: 1px solid black;
}
</style>
